<form [formGroup]="formGrp">
  <div class="NgxEditor__Wrapper">
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
    <ngx-editor outputFormat="html" [editor]="editor" [formControlName]="formCtrlName"></ngx-editor>
  </div>
</form>
